import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";
import { CerrixColorBoxComponent } from "../../atoms/cerrix-color-box/cerrix-color-box.component";
import { CerrixLabelComponent } from "../../atoms/cerrix-label/cerrix-label.component";

@Component({
    selector: "app-cerrix-color-box-label",
    imports: [CerrixColorBoxComponent, CerrixLabelComponent],
    templateUrl: "./cerrix-color-box-label.component.html",
    styleUrl: "./cerrix-color-box-label.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixColorBoxLabelComponent {
    @Input() color?: string;
    @Input() label: string;
}
